// extracted by mini-css-extract-plugin
module.exports = {"status":"styles_status__3WcCT","status_active":"styles_status_active__yHmrx","status_inactive":"styles_status_inactive__1kjim","status_passive":"styles_status_passive__16Rjx"};